import ProfileIcon from './ProfileIcon';

function ProfileButton({ 
    profileUrl, 
    memberName,
    className = '', 
    size = 'medium',
    variant = 'primary',
    disabled = false
}) {
    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        if (disabled || !profileUrl) return;
        
        // Open profile in new tab
        window.open(profileUrl, '_blank', 'noopener,noreferrer');
    };

    const getSizeClass = () => {
        switch (size) {
            case 'small': return 'btn-sm';
            case 'large': return 'btn-lg';
            case 'icon': return 'btn-icon';
            default: return '';
        }
    };

    const getVariantClass = () => {
        switch (variant) {
            case 'secondary': return 'btn-secondary';
            case 'outline': return 'btn-outline';
            default: return 'btn-primary';
        }
    };

    if (!profileUrl) {
        return null;
    }

    return (
        <button
            onClick={handleClick}
            disabled={disabled}
            className={`base-btn profile-btn ${getSizeClass()} ${getVariantClass()} ${className}`}
            title={`View ${memberName}'s profile`}
            aria-label={`View ${memberName}'s profile`}
        >
            <ProfileIcon 
                width={size === 'icon' ? 16 : 14} 
                height={size === 'icon' ? 16 : 14} 
            />
            {(size !== 'icon') && <span className="button-text">View</span>}
        </button>
    );
}

export default ProfileButton;
